import { createFileRoute } from "@tanstack/react-router";

import { getOrganizationOptions } from "@/openapi/@tanstack/react-query.gen";

export const Route = createFileRoute("/_protected/organization/$orgId/")({
  loader: async ({ context: { queryClient }, params, abortController }) => {
    await queryClient.query({
      ...getOrganizationOptions({
        path: { org_id: params.orgId },
        signal: abortController.signal,
      }),
      staleTime: "static",
    });
  },
});
